<template>
    <b-modal :id="'modal-gerenciar-arquivos-primeseg-' + this.usuario.id" size="xl" hide-footer centered title="Gerenciar Arquivos Primeseg">
		<informacoes-usuario :usuario="usuarioSelecionado"/>
        <table-arquivos-primeseg :usuario="usuarioSelecionado"/>
    </b-modal>
</template>

<script>
import InformacoesUsuario from "../usuario/InformacoesUsuario.vue";
import TableArquivosPrimeseg from "./TableArquivosPrimeseg.vue";

export default {
	components: { InformacoesUsuario, TableArquivosPrimeseg },
	name: "ModalGerenciarArquivosUsuario",
	props: [ "usuario" ],
	data() {
		return {
			usuarioSelecionado: this.usuario,
		};
	},

};
</script>



// WEBPACK FOOTER //
// src/components/GerenciarArquivosPrimeseg/ModalGerenciarArquivosPrimeseg.vue